// All data now lives in MySQL and is fetched via the API on login.
// This module just provides the `QH_DATA` skeleton + the BHD formatters that
// the legacy components import implicitly off `window`.

const QH_DATA = {
  currentUser: { id: '', name: '', role: '', email: '', avatarInitials: '' },
  activeRole: { id: '', name: '' },
  permissions: {},
  roles: [],
  pages: [],
  users: [],
  members: [],
  banks: [],
  bankTransfers: [],
  schemes: [],
  events: [],
  transactions: [],
  financeApps: [],
  repayments: [],
  defaulters: [],
  templates: [],
  auditLog: [],
  monthlyDeposits: [],
  dashboardKpis: {},
};

function fmtBHD(n) {
  if (n == null) return '—';
  return Number(n).toLocaleString('en-BH', { minimumFractionDigits: 3, maximumFractionDigits: 3 });
}
function fmtBHDShort(n) {
  if (n == null) return '—';
  if (Math.abs(n) >= 1e6) return (n / 1e6).toFixed(2) + 'M';
  if (Math.abs(n) >= 1e3) return (n / 1e3).toFixed(1) + 'K';
  return n.toFixed(0);
}

// Pretty-print a finance application purpose. For 'other' we show the
// operator-typed PurposeOther (with an "Other" prefix so the label always
// communicates what kind of value it is); for the canonical keys we
// capitalise the snake_case label (debt_settlement → "Debt Settlement").
const PURPOSE_LABELS = {
  marriage: 'Marriage',
  education: 'Education',
  medical: 'Medical',
  housing: 'Housing',
  business: 'Business',
  debt_settlement: 'Debt Settlement',
  deeni: 'Deeni',
  other: 'Other',
  house: 'Housing', // legacy alias surfaced from old rows
};
function formatPurpose(purpose, purposeOther) {
  if (!purpose) return '—';
  if (purpose === 'other' && purposeOther && purposeOther.trim()) {
    return `Other — ${purposeOther.trim()}`;
  }
  return PURPOSE_LABELS[purpose] || purpose;
}

window.QH_DATA = QH_DATA;
window.fmtBHD = fmtBHD;
window.fmtBHDShort = fmtBHDShort;
window.formatPurpose = formatPurpose;
window.PURPOSE_LABELS = PURPOSE_LABELS;
